import wrapPage from './src/components/wrap-page';
export const wrapPageElement = wrapPage;
